import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as createWizardReducer from "containers/CreateWizard/reducer";

import BusinessChooseDataset from "components/CreateWizard/Business/BusinessChooseDataset";
import DatasetViewContainer from "containers/View/Dataset";
import BlueprintViewContainer from "containers/View/Blueprint";

const bId = "businessChooseBlueprint";

class BusinessChooseDatasetContainer extends React.PureComponent {
  handleBlueprintSelection(blueprint) {
    const { updateBlueprintSelection, initCustomBlueprint, updateStep, index, selectedDataset } = this.props;

    if (selectedDataset) {
      updateStep(index + 1);
    }

    const bpId = parseInt(blueprint);

    updateBlueprintSelection(isNaN(bpId) ? blueprint : bpId);
    return initCustomBlueprint(blueprint);
  }

  handleDatasetSelection(dataset) {
    const { updateDatasetSelection, updateStep, index, generateNameAndUpdate, blueprintId, id, selectedBlueprint } =
      this.props;

    if (selectedBlueprint) {
      updateStep(index + 1);
    }

    return updateDatasetSelection(dataset).then(() => {
      if (id === "new" && (blueprintId === "template" || blueprintId === "academic")) {
        return generateNameAndUpdate(dataset);
      }
    });
  }

  render() {
    const { blueprintId, selectedBlueprint } = this.props;

    return (
      <BusinessChooseDataset
        {...this.props}
        blueprintView={
          <BlueprintViewContainer hideFirstTile showQuickStart onClick={(s) => this.handleBlueprintSelection(s)} />
        }
        datasetView={
          <DatasetViewContainer blueprintId={selectedBlueprint} onClick={(s) => this.handleDatasetSelection(s)} />
        }
        updateDataset={(s) => this.handleDatasetSelection(s)}
        updateBlueprint={(s) => this.handleBlueprintSelection(s)}
      />
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateDatasetSelection: (selection) =>
    dispatch(setupReducer.updateDatasetId(ownProps.id, selection, true, ownProps.index, ownProps.blueprintId, true)),
  updateBlueprintSelection: (selection) => dispatch(setupReducer.updateBlueprintId(ownProps.id, selection)),
  initCustomBlueprint: (bpId) => dispatch(setupReducer.initCustomBlueprint(ownProps.id, bpId)),
  generateNameAndUpdate: (datasetId) => dispatch(setupReducer.generateNameAndUpdate(ownProps.id, datasetId)),

  updateStep: (step) => dispatch(createWizardReducer.updateStep(step))
});

const mapStateToProps = (state, ownProps) => {
  const bpId = setupReducer.getBlueprintId(state, ownProps.id);
  const selectedBlueprint = bpId !== "template" && blueprintReducer.getBlueprint(state, bpId);
  return {
    selectedDataset: setupReducer.getDatasetFromSetup(state, ownProps.id),
    selectedBlueprint: selectedBlueprint,
    selectedBlueprintId: bpId,
    step: createWizardReducer.getStep(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(BusinessChooseDatasetContainer);
